// Meta Pixel loader + event helpers. Pixel ID comes from REACT_APP_META_PIXEL_ID.
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const SCRIPT_ID = "meta-pixel-script";

// Official Meta queue/bootstrap pattern, inserted at runtime.
function ensurePixelBootstrap() {
  if (!window.fbq) {
    const fbq = function (...args) {
      fbq.callMethod ? fbq.callMethod(...args) : fbq.queue.push(args);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
    window.fbq = fbq;
  }
  if (!document.getElementById(SCRIPT_ID)) {
    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);
  }
}

export function loadMetaPixel() {
  if (!PIXEL_ID || typeof window === "undefined") {
    if (process.env.NODE_ENV !== "production") {
      console.warn("Meta Pixel disabled: REACT_APP_META_PIXEL_ID is missing");
    }
    return false;
  }

  // Prevent duplicate initialization during React StrictMode remounts.
  if (window.__metaPixelInitialized) return true;

  ensurePixelBootstrap();
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView"); // initial document load only
  window.__metaPixelInitialized = true;
  return true;
}

// Extra pixel for a specific page (e.g. /enquire). Fires its own PageView once;
// afterwards all standard fbq('track', ...) events report to every initialized pixel.
export function initExtraPixel(pixelId) {
  if (!pixelId || typeof window === "undefined") return false;
  window.__extraPixels = window.__extraPixels || new Set();
  if (window.__extraPixels.has(pixelId)) return true;
  ensurePixelBootstrap();
  window.fbq("init", pixelId);
  window.fbq("trackSingle", pixelId, "PageView");
  window.__extraPixels.add(pixelId);
  return true;
}

export function trackPageView() {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", "PageView");
  }
}

export function trackLead(formType) {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    // Lead is a Meta standard event; form_type is custom event data.
    window.fbq("track", "Lead", { form_type: formType });
  }
}
